import controller from './line.controller';
import template from './line.html';

export default {
    controller,
    template,
    bindings: {
        xlabel: '<',
        ylabel: '<',
        xlabels: '<',
        data: '<',
        title: '<',
        height: '<',
        excludedItems: '<',
        onLegendItemToggle: '<'
    }
};



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/graphs/line/line.component.js